import type { SVGProps } from 'react';
const SvgHorizontalRule = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#horizontal_rule_svg__a)">
      <path fill="currentColor" d="M20 11H4v2h16v-2Z" />
    </g>
    <defs>
      <clipPath id="horizontal_rule_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHorizontalRule;
